import { render, staticRenderFns } from "./seller.vue?vue&type=template&id=2a444021"
import script from "./seller.vue?vue&type=script&lang=js"
export * from "./seller.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports